import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, Quote, Star } from 'lucide-react';
import { testimonials } from '../data/mock';

const TestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevTestimonial = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const currentTestimonial = testimonials[currentIndex];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="heading-large text-gray-900 mb-4">
            What Our Students Say
          </h2>
          <p className="body-large text-gray-600 max-w-2xl mx-auto">
            Join thousands of successful students who transformed their careers with Zero To Cloud.
          </p>
        </div>

        <div className="max-w-5xl mx-auto relative px-4 md:px-16">
          {/* Main Testimonial Display */}
          <div className="relative bg-white rounded-xl shadow-lg p-4 md:p-8 lg:p-12 mb-8 border border-blue-100 overflow-hidden">
            <div className="absolute top-4 md:top-6 left-4 md:left-6">
              <Quote className="text-blue-200" size={32} />
            </div>
            
            <div className="relative z-10 transition-all duration-500 ease-in-out transform">
              {/* Stars */}
              <div className="flex justify-center mb-4 md:mb-6">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="text-yellow-400 fill-current" size={16} />
                ))}
              </div>

              {/* Testimonial Text */}
              <blockquote className="text-center mb-6 md:mb-8">
                <p className="text-sm md:text-lg text-gray-700 italic leading-relaxed max-h-32 md:max-h-none overflow-hidden">
                  "{currentTestimonial.text}"
                </p>
              </blockquote>

              {/* Author */}
              <div className="flex items-center justify-center">
                <img 
                  src={currentTestimonial.avatar} 
                  alt={currentTestimonial.name}
                  className="w-12 h-12 md:w-16 md:h-16 rounded-full object-cover mr-3 md:mr-4 transition-all duration-500 ease-in-out"
                />
                <div className="text-left">
                  <div className="font-semibold text-gray-900 text-sm md:text-base">
                    {currentTestimonial.name}
                  </div>
                  <div className="text-gray-600 text-xs md:text-sm">
                    {currentTestimonial.location}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Left Navigation Arrow - Outside the box */}
          <button 
            onClick={prevTestimonial}
            className="absolute -left-1 md:-left-2 top-1/2 transform -translate-y-1/2 p-2 md:p-4 rounded-full bg-white border-2 border-blue-200 shadow-md hover:shadow-lg hover:border-blue-400 transition-all duration-200 text-gray-600 hover:text-blue-600"
            aria-label="Previous testimonial"
          >
            <ChevronLeft size={20} />
          </button>

          {/* Right Navigation Arrow - Outside the box */}
          <button 
            onClick={nextTestimonial}
            className="absolute -right-1 md:-right-2 top-1/2 transform -translate-y-1/2 p-2 md:p-4 rounded-full bg-white border-2 border-blue-200 shadow-md hover:shadow-lg hover:border-blue-400 transition-all duration-200 text-gray-600 hover:text-blue-600"
            aria-label="Next testimonial"
          >
            <ChevronRight size={20} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;